import { jsxs as S, jsx as t } from "react/jsx-runtime";
import { useMemo as k } from "react";
import { a as x } from "../../core-DVmjA3_O.js";
import { _ as o } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import m from "../../hooks/useSpacingToken.js";
import { gapSpacings as p, fullSpacings as L } from "../../utils/style.js";
import '../../index11.css';const j = "_block-layout_1ym5b_1", B = "_children_1ym5b_5", M = "_separator_1ym5b_9", P = "_after-content_1ym5b_15", A = "_before-content_1ym5b_16", D = "_with-overflow_1ym5b_22", e = {
  blockLayout: j,
  children: B,
  separator: M,
  afterContent: P,
  beforeContent: A,
  withOverflow: D
};
function G(h) {
  const {
    className: d,
    elementRef: _,
    before: a,
    children: n,
    after: s,
    beforeContainerClassName: w,
    childrenContainerClassName: C,
    afterContainerClassName: b,
    spacing: i,
    spacingOffset: c,
    withPadding: l,
    withBeforeSeparator: u,
    withAfterSeparator: N,
    withoutSpacingOpticalCorrection: f,
    withOverflow: g,
    ...y
  } = h, v = k(() => l ? L : p, [l]), O = m({
    spacing: i,
    modes: v,
    offset: c,
    withoutOpticalCorrection: f
  }), r = m({
    spacing: i,
    modes: p,
    offset: c,
    withoutOpticalCorrection: f
  });
  return /* @__PURE__ */ S(
    "div",
    {
      ...y,
      className: o(
        e.blockLayout,
        O,
        g && e.withOverflow,
        d
      ),
      ref: _,
      children: [
        a && /* @__PURE__ */ t(
          "div",
          {
            className: o(
              e.beforeContent,
              r,
              w
            ),
            children: a
          }
        ),
        u && /* @__PURE__ */ t("hr", { className: e.separator }),
        x(n) && /* @__PURE__ */ t(
          "div",
          {
            className: o(
              e.children,
              r,
              C
            ),
            children: n
          }
        ),
        N && /* @__PURE__ */ t("hr", { className: e.separator }),
        s && /* @__PURE__ */ t(
          "div",
          {
            className: o(
              e.afterContent,
              b,
              r
            ),
            children: s
          }
        )
      ]
    }
  );
}
export {
  G as default
};
